import { isApp } from '@/views/calculators/services/environmentService';
import { Options, Vue } from 'vue-class-component';
import { PropType } from 'vue';

@Options({
	name: 'menuBlockComponent',
	components: {},
	props: {
		model: Object as PropType<Array<any>>,
	},
})
export default class Menu extends Vue {
	model: Array<any>;
	private windowWidth: number = null;
	public trackingUrl: string;

	beforeMount() {
		this.trackingUrl = '';

		const root = document.documentElement;

		let index = 0;
		this.model.forEach((nav) => {
			root.style.setProperty(`--tab-${index}-nav-icon`, `url(${nav.svgIconReference?.url})`);
			index++;
		});
	}

	mounted() {
		this.windowWidth = innerWidth;
		addEventListener('resize', this.updateWindowWidth);
		addEventListener('click', this.closeNavigation);
		addEventListener('keydown', this.closeNavigation);
	}

	beforeUnmount() {
		removeEventListener('resize', this.updateWindowWidth);
		removeEventListener('click', this.closeNavigation);
		removeEventListener('keydown', this.closeNavigation);
	}

	get menuLabel() {
		return 'Mit Alm. Brand';
	}

	public updateWindowWidth() {
		this.windowWidth = innerWidth;
	}

	public hasSubmenu(route) {
		const isMobile = this.windowWidth < 768;
		return !isMobile && route?.menuPoints?.length > 0;
	}

	public toggleMenu(route) {
		const menu = this.$refs[`sub-menu-${route}`];
		const toggle = this.$refs[`toggle-${route}`];
		const isOpen = (menu as any).classList.contains('open');

		this.closeActiveMenu();

		if (!isOpen) {
			(toggle as any).setAttribute('aria-expanded', 'true');
			(menu as any).classList.add('open');
		}
	}

	public closeActiveMenu() {
		const openMenu = document.querySelector('.primary-navigation__item.open');
		if (openMenu) {
			const openMenuToggle = openMenu.querySelector('.primary-navigation__link--toggle');
			openMenuToggle.setAttribute('aria-expanded', 'false');
			openMenu.classList.remove('open');
		}
	}

	public closeNavigation(event) {
		// If clicked outside menu or pressed ESC
		const cssClass = document.querySelector('.primary-navigation');
		if ((cssClass !== null && !cssClass.contains(event.target)) || event.keyCode === 27) {
			this.closeActiveMenu();
		}
	}

	public logoutUrl() {
		return '/auth/logout?applicationId=almbrand&redirectUri=https://www.almbrand.dk';
	}

	public isLoggedInAsApp() {
		return isApp();
	}
}
